import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import appConfig from '@/appConfig';
import { SFeaturesSelection } from '@slg/web-customer-shared';
import { useStore, useRouteRef } from '@/composables';


const __default__ = {
  name: 'FeaturesSelection',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isValidAmountOfPassenger: {
    type: Boolean,
    default: true,
  },
},
  emits: ['clearBookingRequestError'],
  setup(__props, { emit }) {




const store = useStore();
const route = useRouteRef();

const getAdults = computed(() => store.getters['booking/getAdults']);
const getChildren = computed(() => store.getters['booking/getChildren']);
const getAnimalsTransportation = computed(() => store.getters['booking/getAnimalsTransportation']);
const getRideType = computed(() => store.getters['booking/getRideType']);
const getVehicleCategoryId = computed(() => store.getters['booking/getVehicleCategoryId']);
const getSelectedFeatures = computed(() => store.getters['booking/getSelectedFeatures']);
const getAppConfig = computed(() => appConfig);
const getCurrentLang = computed(() => route.value.params.lang);
const getPassengersAmount = computed(() => getAdults.value + getChildren.value);

function setFeatureAmount(feature: unknown) {
  store.commit('booking/setFeatureAmount', feature);
  emit('clearBookingRequestError');
}

function setAnimalsTransportation(animalsTransportation: boolean) {
  store.commit('booking/setAnimalsTransportation', animalsTransportation);
  emit('clearBookingRequestError');
}

return { __sfc: true,emit, store, route, getAdults, getChildren, getAnimalsTransportation, getRideType, getVehicleCategoryId, getSelectedFeatures, getAppConfig, getCurrentLang, getPassengersAmount, setFeatureAmount, setAnimalsTransportation, SFeaturesSelection }
}

})